import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

function createRow(trait, playerVal, searchVal) {
 return { trait, playerVal, searchVal };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    border: "1px solid black",
    fontSize: 14,

  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    border: "1px solid black",


  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },

}));

const LABELS = ['Height (in)', 'Weight (lb)', 'Hand Size (in)', 'Arm Length (in)', '40 Time (s)',"Bench Press (reps)", "Vertical Leap (in)", "Broad Jump (in)", "Shuttle Time (s)", "3 Cone (s)", "Pick Number", "Round", "Value (wAV)"];

class CreateTable extends React.Component {
  render() {
    const { playerInfo, originalInfo, originalPlayerName, playerName } = this.props;
    const playerRows = LABELS.map((label, i) =>
      createRow(label, playerInfo[i], originalInfo[i])
    );

    return (
      <Table sx={{width:'100%', overflowX:'auto',p: 1, m:1 }}aria-label="customized table" >
        <TableHead>
          <TableRow>
            <StyledTableCell>Trait</StyledTableCell>
            <StyledTableCell >{playerName}</StyledTableCell>
            <StyledTableCell >{originalPlayerName}</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {playerRows.map((row) => (
            <StyledTableRow
              key={row.trait}
            >
              <StyledTableCell  component="th" scope="row">
                {row.trait}
              </StyledTableCell >
              <StyledTableCell  align="right">{row.playerVal}</StyledTableCell >
              <StyledTableCell  align="right">{row.searchVal}</StyledTableCell >
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    );
  }
}
export default CreateTable;
